import React, { useEffect, useState } from "react";
import ProductsCatalogo from "./ProductsCatalogo";
import toast from "react-hot-toast";
import * as api from "helper/helper";
import "./productosTable.css";
import { SubSections } from "../../data/navItem";
import ProductsDashboard from "./ProductsDashboard";
import ProductosCaracteristicas from "./ProductosCaracteristicas";
import ProveedoresCatalogo from "./ProveedoresCatalogo";

function ProductsContainer({ subSectionId }) {
  const [productos, setProductos] = useState({});
  const [filter, setFilter] = useState("Hoy");
  const handleFilterChange = (filter) => {
    setFilter(filter);
  };

  const fetchData = async () => {
    const response = await api.productos().catch(() => {
      toast.error("Error al pedir clientes.");
    });
    if (!response) return;

    setProductos(response.data);

    console.log(response.status);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {subSectionId === SubSections.Dashboard && <ProductsDashboard />}
      {subSectionId === SubSections.Catalogo && <ProductsCatalogo />}
      {subSectionId === SubSections.CaracteristicasSKU && (
        <ProductosCaracteristicas />
      )}
      {subSectionId === SubSections.Proveedores && <ProveedoresCatalogo />}
    </>
  );
}

export default React.memo(ProductsContainer);
